import type { IGroupOfActivityOccurrence } from "@medoma/models/activities";
import { Trans, useLingui } from "@lingui/react/macro";
import DropdownMenu from "@/components/DropdownMenu/DropdownMenu";
import DotsIcon from "@medoma/components/icons/DotsIcon";
import BinIcon from "@medoma/components/icons/BinIcon";
import CalendarDeleteIcon from "@medoma/components/icons/CalendarDeleteIcon";
import ArrowLeftCurveIcon from "@medoma/components/icons/ArrowLeftCurveIcon";
import { isUnfinishedOccurrence } from "@/forms/changeGroupUtils";
import { useDialog } from "@medoma/components/Dialog/useDialog";

const ActivityOccurrenceInGroupDropdownMenu = ({
  occurrence,
  onRemove,
  onCloseSeries,
  onMove,
  isRemoving,
  isClosing,
}: {
  occurrence: IGroupOfActivityOccurrence["occurrences"][number];
  onRemove: (
    occurrence: IGroupOfActivityOccurrence["occurrences"][number],
  ) => void;
  onCloseSeries: (activityId: string) => void;
  onMove: (
    occurrence: IGroupOfActivityOccurrence["occurrences"][number],
  ) => void;
  isRemoving: boolean;
  isClosing: boolean;
}) => {
  const { t } = useLingui();
  const { confirm } = useDialog();

  return (
    <DropdownMenu
      trigger={{
        icon: <DotsIcon />,
        ariaLabel: t`Alternativ`,
      }}
    >
      <DropdownMenu.Item
        action={() => onRemove(occurrence)}
        icon={<BinIcon />}
        content={
          occurrence.recurring ? (
            <Trans>Ta bort tillfälle</Trans>
          ) : (
            <Trans>Ta bort</Trans>
          )
        }
        disabled={isRemoving}
      />
      {occurrence.recurring ? (
        <DropdownMenu.Item
          action={async () => {
            const confirmed = await confirm({
              title: t`Avsluta hela serien`,
              message: t`Alla framtida aktivitetstillfällen kommer att tas bort. Åtgärden går inte att ångra.`,
            });
            if (confirmed) {
              onCloseSeries(occurrence.activityId);
            }
          }}
          icon={<CalendarDeleteIcon />}
          content={<Trans>Avsluta hela serien</Trans>}
          disabled={isClosing}
        />
      ) : null}
      {isUnfinishedOccurrence(occurrence) ? (
        <>
          <DropdownMenu.Separator />
          <DropdownMenu.Item
            action={() => onMove(occurrence)}
            icon={<ArrowLeftCurveIcon />}
            content={<Trans>Flytta</Trans>}
          />
        </>
      ) : null}
    </DropdownMenu>
  );
};

export { ActivityOccurrenceInGroupDropdownMenu };
